export const SETTING_IDS = [1, 2, 3];

export interface AutoAssignType {
    autoAssignTypeId: number;
    currentStatus: string;
    id: number;
    lastUpdateTimestamp: string;
    lastUpdateUserId: number;
    lastUpdateUserName: string;
}
